import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "btn btn-pay-by-app btn-outline-dark",
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('btn:click')), ["prevent"]))
  }, [
    _createElementVNode("span", null, _toDisplayString(_ctx.$t('invoice.pay-by-app')), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appPayLogos, (method) => {
      return (_openBlock(), _createElementBlock("img", {
        key: method,
        class: "app-pay-icon",
        src: _ctx.paymentMethodsHelper.getLogo(method),
        loading: "lazy",
        onerror: "this.src='/img/methods/unknown_method.svg'"
      }, null, 8, _hoisted_1))
    }), 128))
  ]))
}